import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../../utils/assertion.esm.js';
import '../../../utils/ssr.esm.js';
import '../../../utils/number.esm.js';
import '../../../utils/array.esm.js';
import '../../../utils/breakpoint.esm.js';
import '../../../utils/context.esm.js';
import '../../../utils/dom.esm.js';
import '../../../utils/tabbable.esm.js';
import '../../../utils/dom-query.esm.js';
import '../../../utils/logger.esm.js';
import '../../../utils/focus.esm.js';
import '../../../utils/function.esm.js';
import '../../../utils/keydown.esm.js';
import '../../../utils/lazy.esm.js';
import { omit } from '../../../utils/object.esm.js';
import '../../../utils/react-helpers.esm.js';
import '../../../utils/style-props.esm.js';
import '../../../utils/tailwind.esm.js';
import Box from '../../Box/index.esm.js';
import Icon from '../../Icon/index.esm.js';
import { useTableContext } from '../context.esm.js';
import { useTableHeaderCell } from '../use-table.esm.js';

var TableHeaderCell = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var children = props.children,
      sorted = props.sorted,
      onClick = props.onClick,
      rest = _objectWithoutPropertiesLoose(props, ["children", "sorted", "onClick"]);

  var _useTableContext = useTableContext(),
      spacing = _useTableContext.spacing;

  var ownProps = useTableHeaderCell(_extends({}, props, {
    spacing: spacing
  }));

  if (!onClick) {
    return React__default.createElement(Box, _extends({
      as: "th",
      ref: ref
    }, ownProps, rest), children);
  }

  return React__default.createElement(Box, _extends({
    as: "th",
    ref: ref
  }, omit(ownProps, ['padding']), rest), React__default.createElement(Box, {
    as: "button",
    type: "button",
    display: "flex",
    width: "w-full",
    alignItems: "items-center",
    justifyContent: "justify-between",
    group: "group",
    padding: ownProps.padding,
    textTransform: ownProps.textTransform,
    fontWeight: ownProps.fontWeight,
    onClick: onClick
  }, React__default.createElement(Box, {
    as: "span",
    margin: "mr-4"
  }, children), React__default.createElement(Box, {
    as: "span",
    display: "inline-flex",
    margin: "ml-auto",
    padding: "p-1",
    opacity: !sorted ? ['opacity-0', 'group-hover:opacity-100', 'group-focus:opacity-100'] : undefined,
    borderRadius: "rounded",
    backgroundColor: sorted ? 'bg-blue-500' : ['bg-gray-100', 'hover:bg-gray-200', 'focus:bg-gray-200'],
    textColor: sorted ? 'text-white' : 'text-gray-600',
    transitionProperty: "transition-all",
    transitionDuration: "duration-200"
  }, React__default.createElement(Icon, {
    transitionProperty: "transition-transform",
    transitionDuration: "duration-300",
    transform: "transform",
    rotate: sorted === 'desc' ? 'rotate-180' : undefined,
    name: "small-arrow-up"
  }))));
});

if (__DEV__) {
  TableHeaderCell.displayName = 'TableHeaderCell';
}

export default TableHeaderCell;
//# sourceMappingURL=index.esm.js.map
